<button (click)="handleButtonClick()"
        [disabled]="isDisabled"
        [ngClass]="{
        'icon-button-primary': variant === 'primary',
        'icon-button-secondary': variant === 'secondary',
        'icon-button-base': variant === 'base',
        'icon-button-base-l': variant === 'base-l',
        'icon-button-neutral-base': variant === 'neutral-base',
        'icon-button-neutral-base-l': variant === 'neutral-base-l'
        }"
        class="icon-button">
  <ng-content select="[icon]"></ng-content>
  <app-titan-icon *ngIf="iconVariant" [variant]="iconVariant" [size]="iconSize" [displayContents]="true"></app-titan-icon>
</button>
